import classNames from 'classnames';
import { useMemo } from 'react';
import { Utils } from '../../../Common/Utils';
import {
    Card,
    LabelBody,
    LabelBodySmall,
    LabelDisplay1,
    Spacer,
} from '../components';
import { ExerciseStatusView } from './ExerciseStatusView';
import { VideoPlayerIcon } from '../icons';
import { ExerciseDto } from '../interfaces';
import { VideoExerciseView } from './VideoExerciseView';

type Props = {
    exercise: ExerciseDto;
    onVideoPlayed: () => void;
    class?: string;
};
export function VideoCardView({
    exercise,
    onVideoPlayed,
    class: className,
}: Props) {
    const hasLoggedData = useMemo(
        () => Object.keys(exercise.Data).length > 0,
        [exercise],
    );
    return (
        <Card class={className}>
            <div className="mb-10 flex">
                <VideoPlayerIcon />
                <LabelBodySmall className={classNames('ml-10')}>
                    {Utils.formatTimespan(exercise.VideoMetadata.Duration)} min
                </LabelBodySmall>
                <Spacer class="mt-20" />
                <ExerciseStatusView
                    hasLoggedData={hasLoggedData}
                    status={exercise.Status}
                    isVideo={exercise.VideoMetadata != null}
                />
            </div>
            <VideoExerciseView
                className="mb-10"
                exercise={exercise}
                onStartPlaying={onVideoPlayed}
                hideDuration
            />
            <LabelDisplay1 class="mb-10">{exercise.Name}</LabelDisplay1>
            <LabelBody>{exercise.Description}</LabelBody>
        </Card>
    );
}
